// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IeRpW","index":"styles_index__32j4Q"};